import { useSelector, useDispatch } from "react-redux";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { useEffect } from "react";
import { ShopperOriginsGraph } from "../../../../components/Graphs/graphs";
import { graphSocialCounts, SelectSocialCountsStatus, SelectWeeks } from "./trafficSourceSlice";
import { SingleGraphLoading } from "../../../../components/Skeletons";


const TrafficSource = ({ display }) => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername)
  const user = sessionUser?.split('@')[0];
  
  const TrafficSourceData = useSelector(state => state.trafficSource)
  const weeks = useSelector(SelectWeeks)
  const loading = useSelector(SelectSocialCountsStatus);


  
  useEffect(() => {
    if (!user) return null
    if (weeks.length === 0) dispatch(graphSocialCounts(user))
  }, [weeks, user])

  if (loading === 'loading') return <SingleGraphLoading />
  
  return (
    <ShopperOriginsGraph
      {...TrafficSourceData}
    />
  )
}

export default TrafficSource;